module.exports = __webpack_public_path__ + "0a94c809.png";